// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__u_r2T","row":"Node_row__edJKR","label":"Node_label__1z71r","footer":"Node_footer__13SB5"};